import { Typography } from '@mui/material'
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { Offcanvas } from '@/entities/offcanvas'
import { UpdateCanteenForm } from '@/features/update-canteen-from'
import { useCanteenItem } from '@/shared/api/canteen'
import { useRouteOffcanvas } from '@/shared/hooks/use-route-offcanvas'
import { OffcanvasSkeleton } from '@/shared/ui/offcanvas-skeleton'

export const Route = createFileRoute(
  '/_auth/administration/reference-books/canteens/list/update/$canteenId'
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { isOpen, close } = useRouteOffcanvas('../..')
  const { t } = useTranslation()
  const { canteenId } = Route.useParams()
  const {
    data: canteen,
    isLoading,
    isError,
  } = useCanteenItem({ id: canteenId, enabled: !!canteenId })

  return (
    <Offcanvas open={isOpen} onClose={close} title={t('Редактирование столовой')}>
      {isLoading && <OffcanvasSkeleton />}
      {isError && (
        <Typography color="error">{t('Техническая ошибка. Повторите попытку позже')}</Typography>
      )}
      {canteen && <UpdateCanteenForm onClose={close} canteen={canteen} />}
    </Offcanvas>
  )
}
